import RefreshImg from "public/ransomwareProtection/charm_refresh.svg";
import ComplianceImg from "public/ransomwareProtection/grommet-icons_compliance.svg";
import SupportImg from "public/ransomwareProtection/material-symbols_support.svg";
import BillingInfoImg from "public/ransomwareProtection/stash_billing-info.svg";
import VerifYimg from "public/ransomwareProtection/octicon_verified-24.png";
import BugImg from "public/ransomwareProtection/Vector3.svg";

export const WHY_ONEMIND_CONSTANTS = {
  TITLE: "Why Security Teams Choose OneMind ",
  ITEMS: [
    {
      image: BugImg,
      title: "Prevent Ransomware Before Execution",
      content:
        "Block and contain threats using behavior-based AI — before encryption ever begins.",
    },
    {
      image: VerifYimg,
      title: "Zero Trust Access Enforcement",
      content:
        "Only verified users and devices gain access — nothing and no one is trusted by default.",
    },
    {
      image: ComplianceImg,
      title: "Meet Compliance Standards",
      content:
        "Stay audit-ready with support for GDPR, SOC 2, PCI-DSS, and cyber insurance eligibility.",
    },
    {
      image: RefreshImg,
      title: "Neutralize DDoS Attacks in Real Time",
      content:
        "Smart filtering, botnet blocking, and global threat feeds stop floods at the edge.",
    },
    {
      image: SupportImg,
      title: "Ensure Business Continuity",
      content:
        "Maintain service uptime across hybrid and cloud networks, even during active threats.",
    },
    {
      image: BillingInfoImg,
      title: "Minimize Downtime & Revenue Loss",
      content: "Stop attacks before they become outages — or headlines.",
    },
  ],
};
